import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const auth    = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const portal  = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem('portalToken')}` } });

// ── Admin ─────────────────────────────────────────────────────────────────────
const getPodSettings = () =>
  axios.get(`${API_URL}/api/pod/settings`, auth()).then(r => r.data);

const updatePodSettings = (data) =>
  axios.put(`${API_URL}/api/pod/settings`, data, auth()).then(r => r.data);

const getOrderPods = (orderId) =>
  axios.get(`${API_URL}/api/pod/order/${orderId}`, auth()).then(r => r.data);

const deletePod = (id) =>
  axios.delete(`${API_URL}/api/pod/${id}`, auth()).then(r => r.data);

const getAdminUploadUrl = (orderId, contentType, fileSize) =>
  axios.post(`${API_URL}/api/pod/upload-url`, { orderId, contentType, fileSize }, auth()).then(r => r.data);

const saveAdminPhotoPod = (orderId, photoKey, receiverNotes) =>
  axios.post(`${API_URL}/api/pod/photo`, { orderId, photoKey, receiverNotes }, auth()).then(r => r.data);

const saveAdminSignaturePod = (data) =>
  axios.post(`${API_URL}/api/pod/signature`, data, auth()).then(r => r.data);

// ── Portal ────────────────────────────────────────────────────────────────────
const getPortalDeliveries = () =>
  axios.get(`${API_URL}/api/portal/pod/deliveries`, portal()).then(r => r.data);

const getPortalUploadUrl = (orderId, contentType, fileSize) =>
  axios.post(`${API_URL}/api/portal/pod/upload-url`, { orderId, contentType, fileSize }, portal()).then(r => r.data);

const savePhotoPod = (orderId, photoKey, receiverNotes) =>
  axios.post(`${API_URL}/api/portal/pod/photo`, { orderId, photoKey, receiverNotes }, portal()).then(r => r.data);

const saveSignaturePod = (data) =>
  axios.post(`${API_URL}/api/portal/pod/signature`, data, portal()).then(r => r.data);

const getPortalOrderPods = (orderId) =>
  axios.get(`${API_URL}/api/portal/pod/order/${orderId}`, portal()).then(r => r.data);

const podService = {
  getPodSettings,
  updatePodSettings,
  getOrderPods,
  deletePod,
  getAdminUploadUrl,
  saveAdminPhotoPod,
  saveAdminSignaturePod,
  getPortalDeliveries,
  getPortalUploadUrl,
  savePhotoPod,
  saveSignaturePod,
  getPortalOrderPods,
};

export default podService;
